import { Component, Input } from '@angular/core';
import { LoaderService } from './loader.service';

@Component({
  selector: 'tr-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent {
  @Input() isSpinner = false;
  @Input() isFloorplan = false;
  @Input() scale = 1;

  constructor(readonly loaderService: LoaderService) {}
}
